import { configureStore } from '@reduxjs/toolkit'
import cartReducer from "./features/cart/components/reducers/cartReducer";

export const store = configureStore({
  reducer: {
    cart: cartReducer,
  }
});
